(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["limited-time-offers"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {

  var trigger = document.querySelector('#best-coupon-section .js-tap-to-know');
  if (!trigger) return;

  var pageContent = document.getElementById('offers-page-content');
  if (!pageContent) return;

  /* =============================
     CREATE MODAL
  ============================== */

  var modal = document.createElement('div');
  modal.id = 'comforting-deals-modal';
  modal.className = 'cd-modal';

  modal.innerHTML = `
    <div class="cd-dialog">
      <button type="button" class="cd-close" aria-label="Close">&times;</button>
      <div class="cd-content"></div>
    </div>
  `;

  document.body.appendChild(modal);
  modal.querySelector('.cd-content').innerHTML = pageContent.innerHTML;

  var closeBtn = modal.querySelector('.cd-close');

  function openModal() {
    modal.classList.add('cd-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('cd-open');
    document.body.style.overflow = '';
  }

  trigger.addEventListener('click', openModal);
  closeBtn.addEventListener('click', closeModal);

  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  /* =============================
     CATEGORY FILTER LOGIC
  ============================== */

  var productCollections = window.productCollections || [];
  var dealBlocks = modal.querySelectorAll('.cd-deal-wrapper');

  dealBlocks.forEach(function(block) {

    var hasAttribute = block.hasAttribute('data-category');
    var categoriesAttr = block.getAttribute('data-category');

    // If attribute NOT present → show
    if (!hasAttribute) return;

    // If attribute empty → show
    if (!categoriesAttr || categoriesAttr.trim() === "") return;

    var allowedCategories = categoriesAttr
      .split(',')
      .map(function(item) { return item.trim(); });

    var matchFound = allowedCategories.some(function(handle) {
      return productCollections.includes(handle);
    });

    if (!matchFound) {
      block.style.display = "none";
    }

  });

  /* =============================
     HIDE MODAL IF NO OFFERS
  ============================== */

  var visibleDeals = modal.querySelectorAll('.cd-deal-wrapper:not([style*="display: none"])');
  if (visibleDeals.length === 0) {
    trigger.style.display = "none";
  }

  /* =============================
     COUPON COPY LOGIC
  ============================== */

  modal.addEventListener('click', function (e) {

    var btn = e.target.closest('.cd-code');
    if (!btn) return;

    var code = btn.getAttribute('data-code');
    if (!code) return;

    navigator.clipboard.writeText(code).then(function () {

      var span = btn.querySelector('span');
      if (!span) return;

      var originalText = span.innerText;
      span.innerText = "Copied!";

      setTimeout(function () {
        span.innerText = originalText;
      }, 1500);

    });

  });

});
  } catch(e) { console.error(e); }
})();

})();
